import mammoth from 'mammoth';
import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`;

const ACCEPTED_EXTENSIONS = ['.txt', '.docx', '.pdf'];

export function getAcceptedDocumentTypes() {
  return '.txt,.docx,.pdf,text/plain,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
}

export function isAcceptedDocumentFile(file) {
  if (!file) return false;
  const name = file.name.toLowerCase();
  return ACCEPTED_EXTENSIONS.some((ext) => name.endsWith(ext));
}

async function extractPdfText(arrayBuffer) {
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const pages = [];
  for (let i = 1; i <= pdf.numPages; i += 1) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    pages.push(content.items.map((item) => item.str).join(' '));
  }
  return pages.join('\n\n');
}

async function extractDocxText(arrayBuffer) {
  const result = await mammoth.extractRawText({ arrayBuffer });
  return result.value || '';
}

async function extractTxtText(arrayBuffer) {
  return new TextDecoder('utf-8').decode(arrayBuffer);
}

export async function extractTextFromFile(file) {
  if (!isAcceptedDocumentFile(file)) {
    throw new Error('Please upload a .txt, .docx, or .pdf file.');
  }

  const arrayBuffer = await file.arrayBuffer();
  const lower = file.name.toLowerCase();

  if (lower.endsWith('.pdf')) {
    return extractPdfText(arrayBuffer);
  }
  if (lower.endsWith('.docx')) {
    return extractDocxText(arrayBuffer);
  }
  return extractTxtText(arrayBuffer);
}

export function mergeDocumentSources(pastedText, fileTexts = []) {
  const parts = [];
  if (pastedText?.trim()) parts.push(pastedText.trim());
  fileTexts.forEach((text, index) => {
    if (text?.trim()) {
      parts.push(`--- File ${index + 1} ---\n${text.trim()}`);
    }
  });
  return parts.join('\n\n');
}
